import { Alert, Link } from '@mm/components';
import { landmineNames } from '@mm/constants/landmine-names';
import { CampaignType } from '@mm/state/model/CampaignsModel';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { activeFacebookPageSelector } from '@mm/state/selectors/facebookPageSelector';
import { combinedFeatureFlagsSelector } from '@mm/state/selectors/featureFlagsSelectors';
import { defaultProPlanSelector } from '@mm/state/selectors/subscriptionSelectors';
import classNames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';
import { useLandmineOpensHelpers } from '../../../../../common/modals/UniversalUpgradeModal/useLandmineOpensHelpers';

type Props = {
  className?: string;
  text: string;
};

const REASONS = {
  trial: 'PromoCode',
  subscription: 'Subscription',
};

export const useGetTextByCampaignReasons = (
  ...args: (CampaignType['cancelReason'] | undefined)[]
) => {
  const canUseDrips = useSelector(
    combinedFeatureFlagsSelector,
  ).audiencesExportContacts;

  const { november2021Pricing } = useSelector(combinedFeatureFlagsSelector);

  const reasons = args.filter(Boolean);

  const hasFreeTrialEnded = reasons.some(reason =>
    reason?.includes(REASONS.trial),
  );

  if (hasFreeTrialEnded && !canUseDrips) {
    return 'Your Free Trial has expired. To continue using drip campaigns';
  }

  const hasSubscriptionEnded = reasons.some(reason =>
    reason?.includes(REASONS.subscription),
  );

  if (hasSubscriptionEnded && !canUseDrips) {
    return `You no longer have access to this ${
      november2021Pricing ? 'Startup' : 'Operator'
    } feature. To continue using drip campaigns`;
  }
};

export const InactiveDripAlert = ({ className, text }: Props) => {
  const facebookPage = useSelector(activeFacebookPageSelector);
  const modalActions = useModalActions();
  const defaultProPlan = useSelector(defaultProPlanSelector);
  const { november2021Pricing } = useSelector(combinedFeatureFlagsSelector);

  const { landmineOpenId, landmineOpensCRUDActions } = useLandmineOpensHelpers(
    landmineNames.DRIP_CAMPAIGN_ALERT_UPGRADE_BUTTON,
    'pro',
  );

  const onAlertClick = () => {
    if (landmineOpenId) {
      landmineOpensCRUDActions.update(landmineOpenId, true);

      if (defaultProPlan) {
        modalActions.openBillingModal({
          facebookPage,
          plan: defaultProPlan,
          landmineOpenId,
          stayOnPage: false,
        });
      }
    }
  };

  return (
    <Alert
      className={classNames(className)}
      borderRadius={0}
      type="warning"
      onClick={onAlertClick}
    >
      <div>
        <span>{text} </span>

        <Link
          href=""
          className="drip-campaign-detail__alert-action"
          onClick={e => e.preventDefault()}
        >
          Upgrade to {november2021Pricing ? 'STARTUP' : 'OPERATOR'}
        </Link>
      </div>
    </Alert>
  );
};
